/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import en from '../locales/en.json';
import ru from '../locales/ru.json';
import de from '../locales/de.json';
import el from '../locales/el.json';
import it from '../locales/it.json';
import he from '../locales/he.json';
import pl from '../locales/pl.json';
import nl from '../locales/nl.json';
import fr from '../locales/fr.json';
import pt from '../locales/pt.json';
import tr from '../locales/tr.json';
import es from '../locales/es.json';
import ja from '../locales/ja.json';

type ReplacerType = {
  pattern: string;
  replacer: any;
};

const MESSAGES_ALL = {
  en,
  ru,
  de,
  el,
  it,
  he,
  pl,
  nl,
  fr,
  pt,
  tr,
  es,
  ja,
};

export type SupportedMessagesType = keyof typeof MESSAGES_ALL;

export class Localization {
  private locale: string;

  private bundle: { [id: string]: string };

  constructor() {
    const language = window.navigator.language.slice(0, 2).toLowerCase();

    this.setLocale(language as any);
  }

  setLocale = (locale?: SupportedMessagesType) => {
    this.locale = locale && MESSAGES_ALL[locale] ? locale : 'en';
    this.bundle = MESSAGES_ALL[this.locale];
  };

  getLocale = () => this.locale;

  getString(id: string, replacer?: ReplacerType): string | any[] {
    const value = this.bundle[id];

    if (!value) {
      return '';
    }

    if (!replacer) {
      return value;
    }

    const splitted = value.split(replacer.pattern);

    if (splitted.length > 1) {
      return [
        splitted[0],
        replacer.replacer,
        splitted[1],
      ];
    }

    return value;
  }
}

export const l10n = new Localization();
export const getString = l10n.getString.bind(l10n);
